<div class="file-upload-container">
  <ng-container *ngIf="showUploader && !hideFileUpload">
    <ng-container *ngTemplateOutlet="uploaderContent"></ng-container>
  </ng-container>
  <ng-container *ngIf="showFileList && view !== 'button'">
    <div *ngFor="let file of fileList">
      <ng-container *ngIf="uploadFlow">
        <ng-container *ngTemplateOutlet="uploadFlowTemplate; context: { $implicit: file }"></ng-container>
      </ng-container>
      <ng-container *ngIf="!uploadFlow">
        <ng-container
          *ngTemplateOutlet="
            attachmentFlowTemplate;
            context: { $implicit: file }
          "
        ></ng-container>
      </ng-container>
    </div>
  </ng-container>
  <ng-container *ngIf="fileUploadFailed && view !== 'button'">
    <ng-container *ngTemplateOutlet="errorContent"></ng-container>
  </ng-container>
  <ng-container *ngIf="displayPlaceholder?.authUrl">
    <ng-container *ngTemplateOutlet="placeholderTemplate"></ng-container>
  </ng-container>
</div>

<ng-template #uploaderContent>
  <ng-container *ngIf="view === 'button'; else dragdrop">
    <cm-basic-button
      [size]="BasicButtonSizes.MEDIUM"
      [mode]="BasicButtonModes.FILLED"
      [color]="BasicButtonColors.PRIMARY"
      [disabled]="disabledButton"
      (clickEvent)="fileInput.click()"
    >
      {{ buttonLabel | translate }}
    </cm-basic-button>
    <input
      style="display: none"
      #fileInput
      type="file"
      [accept]="extensions[type]?.accept"
      (change)="fileEvent($event)"
      [attr.data-cy]="dataCy + '-upload'"
    />
  </ng-container>
  <ng-template #dragdrop>
    <div class="file-upload">
      <input
        #fileInput
        type="file"
        [accept]="extensions[type]?.accept"
        (change)="fileEvent($event)"
        [attr.data-cy]="dataCy + '-upload'"
      />
      <div class="file-upload-title">
        <span class="file-upload-title--link">{{ 'file-upload.clickingHere' | translate }}</span>
        {{ 'file-upload.dragAndDropFiles' | translate }}
      </div>
      <div class="file-upload-extension">
        <span *ngIf="extensions[type]">{{ extensions[type]?.label }}</span>
        {{ 'file-upload.maximumFileSize25' | translate }}
      </div>
    </div>
  </ng-template>
</ng-template>

<ng-template #errorContent>
  <input
    class="file-upload-button"
    #fileInput
    type="file"
    [accept]="extensions[type]?.accept"
    (change)="fileEvent($event)"
    [attr.data-cy]="dataCy + '-upload'"
  />
  <div class="file-upload-failed">
    <div>
      <mat-icon class="material-icons-outlined">info</mat-icon>
      <span>{{ 'file-upload.upload-failed' | translate }}</span>
    </div>
    <div>
      <cm-basic-button [size]="BasicButtonSizes.MEDIUM" (clickEvent)="onUploadClick()"
        >{{ 'file-upload.upload-new-file' | translate }}
      </cm-basic-button>
      <div class="action-buttons">
        <cm-icon-button
          [matMenuTriggerFor]="docActionMenu"
          #clickDocActionMenu="matMenuTrigger"
          data-cy="file-item-action-menu"
          icon="more_vert"
        ></cm-icon-button>
        <mat-menu class="doc-action-menu" #docActionMenu="matMenu" xPosition="before">
          <button [disabled]="fileHasParsingErrors" (click)="onDownloadErrors()" mat-menu-item>
            <span>{{ 'file-upload.download-csv' | translate }}</span>
          </button>
        </mat-menu>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #uploadFlowTemplate let-file>
  <div class="file-item file-item--uploadFlow">
    <div class="file-item__details">
      <span>{{ file.name }}</span>
      <ng-container *ngTemplateOutlet="fileStatusTemplate; context: { $implicit: file }"></ng-container>
    </div>
    <ng-container *ngTemplateOutlet="fileItemActions; context: { $implicit: file }"></ng-container>
  </div>
</ng-template>

<ng-template #placeholderTemplate>
  <div class="file-item">
    <div
      class="item-details {{ type }}"
      [ngStyle]="{
      'align-items': 'center',
      width: 'inherit'
    }"
    >
      <div class="upload-image">
        <img [src]="displayPlaceholder.authUrl" (error)="handleImageError($event, displayPlaceholder)" />
      </div>
      <div
        class="file-info"
        [ngStyle]="{
        width: 'inherit'
      }"
      >
        <a data-cy="logo-url" [href]="displayPlaceholder.authUrl" target="_blank" class="file-name ellipsis">
          {{ displayPlaceholder.name || displayPlaceholder.authUrl | urlFileName }}
        </a>
      </div>
    </div>
    <div class="file-item__actions">
      <cm-icon-button (clickEvent)="removePlaceholder.emit()" data-cy="file-remove" icon="close"></cm-icon-button>
    </div>
  </div>
</ng-template>

<ng-template #attachmentFlowTemplate let-file>
  <div class="file-item" [ngClass]="{ 'file-with-errors': file.error }">
    <div
      class="item-details {{ type }}"
      [ngStyle]="{
        'align-items': file?.editName ? 'flex-start' : 'center',
        width: file?.editName ? '100%' : 'inherit'
      }"
    >
      <mat-icon *ngIf="type === 'document' || type === 'csv'" class="upload-icon">
        {{ file?.url | extensionIcon }}
      </mat-icon>
      <div
        *ngIf="(type === 'image' || type === 'logotype') && file?.authUrl"
        class="upload-image"
        (error)="handleImageError($event)"
      >
        <img [src]="file.authUrl" (error)="handleImageError($event, file)" />
      </div>
      <div
        *ngIf="file.url"
        class="file-info"
        [ngStyle]="{
          width: file?.editName ? '100%' : 'inherit'
        }"
      >
        <a *ngIf="!file.error && !file?.editName" [href]="file.authUrl" target="_blank" class="file-name ellipsis">
          {{ file.name || (file.url | urlFileName) }}
        </a>
        <div class="file-name" *ngIf="file.error">{{ 'file-upload.uploadFailed' | translate }}</div>
        <cm-text-field
          class="rename-input"
          *ngIf="type === 'document' && file?.editName"
          (onBlur)="
            !file.savingName && (file.editName = false) && (modifiedFile = null)
          "
          [value]="file?.name | urlFileName: { noExtension: true }"
          (valueChange)="setNewName($event, file.url, file.index)"
          rightIcon="done"
          [label]="'file-upload.fileName' | translate"
          (rightIconOnClick)="
            modifiedFile && !file.savingName && saveNewName(file.index)
          "
          mode="outline"
          [rightIconColor]="file.savingName ? 'disabled' : 'primary'"
          [autofocus]="true"
          [disabled]="file.savingName"
          (onEnter)="
            modifiedFile && !file.savingName && saveNewName(file.index)
          "
        ></cm-text-field>
        <ng-container *ngTemplateOutlet="fileStatusTemplate; context: { $implicit: file }"></ng-container>
      </div>
    </div>
    <ng-container *ngTemplateOutlet="fileItemActions; context: { $implicit: file }"></ng-container>
  </div>
</ng-template>

<ng-template #fileStatusTemplate let-file>
  <div class="file-item__status-info">
    <span *ngIf="uploadFlow">{{ file.sizeInKB }}</span>
    <span *ngIf="uploadFlow" [innerHTML]="dotCharacter"></span>
    <ng-container *ngIf="file.isNew">
      <span *ngIf="(file.url && !file.error) || (uploadFlow && !fileIsLoading)">
        {{ 'file-upload.complete' | translate }}
      </span>
      <span *ngIf="fileIsLoading && !file.url && !file.error"> {{ 'file-upload.loading' | translate }} </span>
    </ng-container>
  </div>
</ng-template>

<ng-template #fileItemActions let-file>
  <div class="action-buttons" *ngIf="!file.editName && !hideMoreActions">
    <cm-icon-button
      [matMenuTriggerFor]="docActionMenu"
      #clickDocActionMenu="matMenuTrigger"
      *ngIf="type === 'document' && !uploadingFile"
      data-cy="file-item-action-menu"
      icon="more_vert"
    ></cm-icon-button>
    <mat-menu class="doc-action-menu" #docActionMenu="matMenu" xPosition="before">
      <button (click)="initAction(item.action, file.index)" *ngFor="let item of docActionMenuItems" mat-menu-item>
        <span>{{ item.label | translate }}</span>
      </button>
    </mat-menu>
  </div>
  <div class="file-item__actions">
    <cm-icon-button
      (clickEvent)="onRemoveFile(file.index)"
      data-cy="file-remove"
      icon="close"
      [disabled]="fileIsProcessing"
    ></cm-icon-button>
    <mat-spinner
      *ngIf="fileIsLoading && !file.url && !file.error"
      id="fileUploadSpinner"
      class="primary-spinner"
      [diameter]="spinnerDiameter"
    ></mat-spinner>
  </div>
</ng-template>
